export const FORM_FIELD_TITLE_MAX_LEN = 255
export const FORM_FIELD_DESCRIPTION_MAX_LEN = 1000
